import { isAfter, subMinutes } from 'date-fns';
import { BackendAlarm } from '../../../alarm/alarm-definitions/backend-alarm';
import { ILayer } from '../../../shared/map/layer/layer.type';
import { _ } from '../../../shared/utils';
import { ScheduleTrain } from '../common/train';

export function getTrainLayer(): ILayer {
  return {
    id: 'Junat',
    name: _('Trains'),
    title: 'Junat',
    source: 'trains',
    asMarkers: true,
    selectable: true,
    style: {
      visible: true
    },
    metadata: {
      group: 'Trains',
      component: 'TrainInfoComponent',
      hoverComponent: 'TrainHover',
      hoverProperties: {
        coordinates: false,
        properties: ['tripNumber', 'category', 'label']
      },
      uniqueBy: '_id',
      labelBy: 'label',
      detailsComponent: 'train-details',
      zoomLevel: 15, // === 2km
    },
    searchOptions: {
      searchable: true,
      minimumSearchTermLength: 1,
      interestingProperties: [
        {key: 'tripNumber', type: 'startsWith'},
        {key: 'category', type: 'startsWith'},
        {key: 'label', type: 'startsWith'},
        {key: 'equipment', type: 'equals'}
      ],
    },
    useWorker: true
  };
}

export function getEquipmentLayer(): ILayer {
  return {
    id: 'Kalusto',
    name: _('Equipment'),
    title: 'Kalusto',
    source: 'equipment',
    asMarkers: true,
    selectable: true,
    style: {
      visible: true
    },
    metadata: {
      group: 'Kalusto',
      component: 'TrainInfoComponent',
      hoverComponent: 'TrainHover',
      hoverProperties: {
        coordinates: false,
        properties: ['equipment', 'title', 'label']
      },
      uniqueBy: '_id',
      labelBy: 'label',
      zoomLevel: 15, // === 2km
    },
    searchOptions: {
      searchable: true,
      interestingProperties: [
        {key: 'equipment', type: 'startsWith'},
        {key: 'title', type: 'startsWith'},
        {key: 'label', type: 'startsWith'},
        {key: 'subTitle', type: 'startsWith'}
      ],
      minimumSearchTermLength: 3,
    },
    useWorker: true
  };
}

export const getScheduleTrainWithStatus = (train: ScheduleTrain) => {
  const currentDate = new Date();
  const freightTime = subMinutes(currentDate, 30);
  const passengerTime = subMinutes(currentDate, 3);
  let status = 'success'
  if (train.category.startsWith('T') ? isAfter(freightTime, train.depTime) : isAfter(passengerTime, train.depTime)) {
    status = 'danger';
  } else if (isAfter(currentDate, train.depTime)) {
    status = 'warning';
  } else {
    status = 'success';
  }
  return {
    status,
    ...train
  };
};

export const getDefaultTabIdForAlarmType = (alarmType: BackendAlarm['type']) => {
  switch (alarmType) {
    case 'vrTrainConflict':
      return 'dependencies';
    case 'vrShiftConflict':
      return 'personel';
    case 'trainDeparture':
    case 'vrTrainStopped':
    case 'vrOverheating':
    case 'vrVoltageAlert':
    case 'vrWheelAlert':
    default:
      return 'schedule';
  }
};